var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hicon",
    clipPath: "url(#clip0_776_10406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Time Circle 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.50033 4.8125C7.50033 4.53636 7.27647 4.3125 7.00033 4.3125C6.72418 4.3125 6.50033 4.53636 6.50033 4.8125H7.50033ZM5.46986 8.62361C5.28042 8.82453 5.28974 9.14098 5.49066 9.33041C5.69158 9.51984 6.00803 9.51052 6.19746 9.3096L5.46986 8.62361ZM6.45554 8.307L6.09174 7.964L6.45554 8.307ZM6.50033 4.8125V6.93501H7.50033V4.8125H6.50033ZM6.19746 9.3096L6.81934 8.65L6.09174 7.964L5.46986 8.62361L6.19746 9.3096ZM12.3337 7.14583C12.3337 10.0914 9.94584 12.4792 7.00033 12.4792V13.4792C10.4981 13.4792 13.3337 10.6436 13.3337 7.14583H12.3337ZM7.00033 12.4792C4.05481 12.4792 1.66699 10.0914 1.66699 7.14583H0.666992C0.666992 10.6436 3.50252 13.4792 7.00033 13.4792V12.4792ZM1.66699 7.14583C1.66699 4.20031 4.05481 1.8125 7.00033 1.8125V0.8125C3.50252 0.8125 0.666992 3.64803 0.666992 7.14583H1.66699ZM7.00033 1.8125C9.94584 1.8125 12.3337 4.20031 12.3337 7.14583H13.3337C13.3337 3.64803 10.4981 0.8125 7.00033 0.8125V1.8125ZM6.50033 6.93501C6.50033 7.31756 6.35416 7.68566 6.09174 7.964L6.81934 8.65C7.25672 8.18609 7.50033 7.57259 7.50033 6.93501H6.50033Z",
    fill: "#B18E0A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_776_10406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockProgress);
export default __webpack_public_path__ + "static/media/clock-progress.8e0fe69e4d8adf60d3ab64dac683b30a.svg";
export { ForwardRef as ReactComponent };